var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconVertAlignTop24Line = function SvgIconVertAlignTop24Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "inherit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 5.768h-13v1.7h13v-1.7ZM12 9.398a1.465 1.465 0 0 0-1.05.45l-3 3.175 1.205 1.17 2-2.095v7.5h1.7v-7.5l2 2.095 1.23-1.175-3-3.175A1.455 1.455 0 0 0 12 9.398Z"
  }))));
};
export default SvgIconVertAlignTop24Line;